import * as React from 'react'

import { Text, TextName } from 'sdk'
import { Pill } from 'sdk/pill/Pill'

import type { ResourcesTieredPlansCmsContent } from 'core/services/cms/interfaces'

import classes from './TieredPlansSection.module.scss'

interface TieredPlansSectionProps {
  content: ResourcesTieredPlansCmsContent
}

export const TieredPlansSection: React.FC<TieredPlansSectionProps> = ({ content }) => {
  return (
    <section className={classes.wrapper}>
      <Text type={TextName.H2}>{content.title}</Text>
      <div className={classes.cardsContainer}>
        {content.plans.map((plan) => (
          <div key={plan.label} className={classes.card}>
            <Pill variant='gradient' className={classes.pill}>
              <div className={classes.pillContent}>
                <img src={plan.iconUrl} alt='' className={classes.icon} />
                <Text type={TextName.Text}>{plan.label}</Text>
              </div>
            </Pill>

            <div className={classes.planBox}>
              <Text type={TextName.H3}>{plan.essential.title}</Text>
              <ul className={classes.list}>
                {plan.essential.items.map((item) => (
                  <li key={item}>
                    <Text type={TextName.Text}>{item}</Text>
                  </li>
                ))}
              </ul>
            </div>

            <div className={classes.planBoxGradient}>
              <Text type={TextName.H3}>{plan.premium.title}</Text>
              <ul className={classes.list}>
                {plan.premium.items.map((item) => (
                  <li key={item}>
                    <Text type={TextName.Text}>{item}</Text>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
